import { CreateBackofficeUser } from "../graphql/mutation/ createBackofficeUser";
import { CreateClients } from "../graphql/mutation/createClients";
import { CreateMachine } from "../graphql/mutation/createMachine";
import { CreateTechnicians } from "../graphql/mutation/createTechnicians";
import { Machine } from "../graphql/querys/machine";
import { Machines } from "../graphql/querys/machines";

export function requestsToUse(type) {
	switch (type) {
		case "clients":
			return {
				queryAll: "clients",
				mutationCreate: CreateClients,
				mutationUpdate: "UpdateClients",
				mutationDelete: "disableUser",
			};
			break;
		case "machines":
			return {
				queryAll: Machines,
				queryOne: Machine,
				mutationCreate: CreateMachine,
				mutationUpdate: "updateMachine",
				mutationDelete: "disableMachine",
			};
		case "technicians":
			return {
				queryAll: "clients",
				mutationCreate: CreateTechnicians,
				mutationUpdate: "UpdateClients",
				mutationDelete: "disableUser",
			};
			break;
		case "backofficeWorkers":
			return {
				queryAll: "clients",
				mutationCreate: CreateBackofficeUser,
				mutationUpdate: "UpdateClients",
				mutationDelete: "disableUser",
			};
			break;
	}
}
export function getFields(type) {
	switch (type) {
	case "clients":
		return [
			{ fieldName: "avatar", type: "image" },
			{ fieldName: "name", type: "string" },
			{ fieldName: "phoneNumber", type: "string" },
			{ fieldName: "nif", type: "string" },

			{
				fieldName: "addressInfo",
				type: "multiple",
				fields: [
					{ fieldName: "Address", type: "string" },
					{ fieldName: "postalCode", type: "string" },
				],
			},
			{ fieldName: "localidade", type: "string" },
			{ fieldName: "email", type: "string" },
		];

			break;
		case "machines":
			return [
				{
					fieldName: "photo",
					type: "image",
				},
				{ fieldName: "name", type: "string" },
				{ fieldName: "ref", type: "string" },
				{
					fieldName: "category",
					type: "select",
					selectFields: ["Máquina"],
				},
				{ fieldName: "status", type: "nonAlterableOnCreate" },
			];

			break;
	case "technicians":
		return [
			{ fieldName: "avatar", type: "image" },
			{ fieldName: "name", type: "string" },
			{ fieldName: "phoneNumber", type: "string" },
			{
				fieldName: "addressInfo",
				type: "multiple",
				fields: [
					{ fieldName: "Address", type: "string" },
					{ fieldName: "postalCode", type: "string" },
				],
			},
			{ fieldName: "localidade", type: "string" },
			{ fieldName: "email", type: "string" },
			{ fieldName: "password", type: "string" },
		];

		break;
	case "backofficeWorkers":
		return [
			{ fieldName: "avatar", type: "image" },
			{ fieldName: "name", type: "string" },
			{ fieldName: "phoneNumber", type: "string" },
			{
				fieldName: "addressInfo",
				type: "multiple",
				fields: [
					{ fieldName: "Address", type: "string" },
					{ fieldName: "postalCode", type: "string" },
				],
			},
			{ fieldName: "localidade", type: "string" },
			{ fieldName: "email", type: "string" },
			{ fieldName: "password", type: "string" },
		];

			break;
	}
}
export function getFieldsRead(type) {
	switch (type) {
		case "clients":
			return [
				{ fieldName: "avatar", type: "image" },
				{ fieldName: "name", type: "string" },
			];

			break;
		case "machines":
			return [
				{
					fieldName: "photo",
					type: "image",
				},
				{ fieldName: "name", type: "string" },
				{ fieldName: "status", type: "nonAlterableOnCreate" },
			];
		case "technicians":
			return [
				{ fieldName: "avatar", type: "image" },
				{ fieldName: "name", type: "string" },
				{ fieldName: "phoneNumber", type: "string" },

				{ fieldName: "email", type: "string" },
			];

			break;
		case "backofficeWorkers":
			return [
				{ fieldName: "avatar", type: "image" },
				{ fieldName: "name", type: "string" },
				{ fieldName: "phoneNumber", type: "string" },
				{
					fieldName: "addressInfo",
					type: "multiple",
					fields: [
						{ fieldName: "address", type: "string" },
						{ fieldName: "postalCode", type: "string" },
					],
				},
				{ fieldName: "email", type: "string" },
			];

			break;
	}
}
export function convertStringToArray(str) {
	// Remove the leading slash ("/") and split the string at each "/"
	const parts = str.substring(1).split("/");

	// Return the resulting array
	return parts;
}

export function validarNIF(nif) {
	// garantir que é string e só tem dígitos
	nif = String(nif);
	if (!/^\d{9}$/.test(nif)) return false;

	// primeiros dígitos válidos
	const primeirosValidos = ["1", "2", "3", "5", "6", "8", "9"];
	if (!primeirosValidos.includes(nif[0])) return false;

	// cálculo do dígito de controlo (módulo 11)
	let soma = 0;
	for (let i = 0; i < 8; i++) {
		soma += parseInt(nif[i], 10) * (9 - i);
	}
	let resto = soma % 11;
	let checkDigit = resto === 0 || resto === 1 ? 0 : 11 - resto;

	return checkDigit === parseInt(nif[8], 10);
}

const normalizeErrorCode = (code) => {
	if (!code) return "";
	if (Array.isArray(code)) return normalizeErrorCode(code[0]);
	if (typeof code === "object") return normalizeErrorCode(code.message);
	return String(code);
};

const getErrorCode = (err) => {
	if (!err) return "";
	if (typeof err === "string") return err;

	return (
		normalizeErrorCode(err?.graphQLErrors?.[0]?.extensions?.exception?.response?.message) ||
		normalizeErrorCode(err?.graphQLErrors?.[0]?.extensions?.response?.message) ||
		normalizeErrorCode(err?.graphQLErrors?.[0]?.message) ||
		normalizeErrorCode(err?.networkError?.result?.errors?.[0]?.message) ||
		normalizeErrorCode(err?.networkError?.result?.message) ||
		normalizeErrorCode(err?.response?.data?.message) ||
		normalizeErrorCode(err?.message) ||
		""
	);
};

const ERROR_FIELD_LABELS = {
	name: "Nome",
	email: "Email",
	password: "Palavra-passe",
	phoneNumber: "Telefone",
};

const formatPtList = (items) => {
	if (items.length <= 1) return items.join("");
	if (items.length === 2) return `${items[0]} e ${items[1]}`;
	return `${items.slice(0, -1).join(", ")} e ${items[items.length - 1]}`;
};

export function getErrorMessage(err) {
	const code = getErrorCode(err);
	const [baseCode, detail] = code.split(":");

	if (baseCode === "AUTH.TECHNICIAN_MISSING_REQUIRED_FIELDS") {
		const fields = detail
			?.split(",")
			.map((field) => ERROR_FIELD_LABELS[field] || field)
			.filter(Boolean);

		if (fields?.length) {
			return `Preencha os campos obrigatórios do técnico: ${formatPtList(fields)}.`;
		}

		return "Preencha os campos obrigatórios do técnico.";
	}

	switch (code) {
		case "AUTH.MISSING_REFRESH_TOKEN":
			return "Falta Token de Acesso";
		case "AUTH.USER_ALREADY_EXISTS":
			return "Já existe um utilizador com estes dados.";
		case "AUTH.THERE_ARE_EMPTY_FIELDS":
			return "Existem campos por preencher.";
		case "ITEM.COUNT_HAS_TO_BE_SUPERIOR_THAN_0":
			return "Quantidade tem de ser maior que 0";
		case "ITEM.ALREADY_RENTED":
			return "Esta máquina já está alugada.";
		case "ITEM_PROVIDED_DOESNT_HAVE_STOCK":
			return "Item não tem stock";
		case "RENTING.NOT_FOUND":
			return "Aluguer não encontrado.";
		case "RENTING.NOT_ACTIVE":
			return "Este aluguer já não está ativo.";
		default:
			return code || "Ocorreu um erro. Tente novamente.";
	}
}
